import { Box, makeStyles, TextField, Typography } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { useActions, useValues } from 'kea';
import PropTypes from "prop-types";
import React from "react";

import profilelogic from "src/store/profile";

import checkRole from "src/utils/checkRole";
import AddVehicleDialog from './AddVehicleDialog';
import AssignGroupDialog from './AssignGroupDialog';
import RemoveGeofenceDialog from './RemoveGeofenceDialog';

const useStyles = makeStyles((theme) => ({
	root: {},
	importButton: {
		marginRight: theme.spacing(1),
	},
	exportButton: {
		marginRight: theme.spacing(1),
	},
	formControl: {
		minWidth: 400,
	}
}));

const Toolbar = ({ select_filter, rows, selectedGeofence }) => {
	const classes = useStyles();
	let set_select_filter = select_filter;
	const { profile } = useValues(profilelogic);
	const [geofence, setGeofence] = React.useState("");

	const reset = () => {
		setGeofence('');
		set_select_filter(null)
	}

	const handle_select = (e) => {
		setGeofence(e.target.value);
		set_select_filter(e.target.value);
	};

	return (
		<div>
			<Box mt={3}
			// display="flex" flexDriection="row"
			>
				<Box >
					{/* <FormGroup row> */}
					<div style={{ display: 'flex', flexGrow: 1 }}>
						{rows.length === 0 ?
							<Typography>Please Create a Geofence First</Typography>
							:
							<>
								<TextField
									id="outlined-select-geofence"
									select
									error={geofence === "" ? true : false}
									label="Select a Geofence"
									value={geofence}
									onChange={handle_select}
									helperText={geofence === "" ? "Please select a Geofence" : null}
									variant="outlined"
									className={classes.formControl}
									style={{
										width: "400px",

									}}
								>
									{rows.map((row, index) => {
										return (
											<MenuItem key={index} value={index}>
												<div style={{
													display: 'flex',
													flexGrow: '1'
												}}>
													<div style={{
														width: '16px',
														marginTop: '2px',
														height: '16px',
														borderRadius: '16px',
														border: `3px solid ${row.polygon.properties.strokeColor}`,
														marginRight: '10px'
													}}>
														<div style={{
															opacity: '0.35',
															width: '100%',
															height: '100%',
															borderRadius: '16px',
															background: `${row.polygon.properties.fillColor}`,
															marginRight: '10px'
														}}>
														</div>
													</div>
													{`${row.name}`}
												</div>
											</MenuItem>
										);
									})}
								</TextField>
								{
									selectedGeofence ?
										<>
											{checkRole(profile, ['GeofenceEdit']) && <AddVehicleDialog geofenceIndex={geofence} selectedGeofence={selectedGeofence} />}
											{checkRole(profile, ['Admin']) && <AssignGroupDialog selectedGeofence={selectedGeofence} />}
											{checkRole(profile, ['Admin']) && <RemoveGeofenceDialog geofence={selectedGeofence} reset={reset} />}
										</>
										:
										null
								}
							</>
						}
					</div>
					{/* </FormGroup> */}

					{/* <Box ml="auto" style={{ paddingTop: '15px' }}> */}
				</Box>
			</Box>
		</div>
	);
};

Toolbar.propTypes = {
	className: PropTypes.string,
};

export default Toolbar;
